import type { FuncOverrideComponent } from '../theme.types';

export const MuiDialog: FuncOverrideComponent<'MuiDialog'> = () => ({
  styleOverrides: {
    paper: {
      borderRadius: '10px',
    },
  },
});
